import React from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const IconButton = withStyles((theme: any) => ({
  root: (props: any) =>
    props.variant === 'outlined' && {
      border: `1px solid ${theme.palette.grey[400]}`,
    },
}))((props: any) => <MuiIconButton {...props} />);

export default IconButton;
